import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=a23c1460&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/blocks/Footer.vue').default})
